// extracted by mini-css-extract-plugin
export default {"tagContainer":"TagContainer_tagContainer__aG4fh"};